/* eslint-disable import/prefer-default-export */
import { getECSDeployLevel } from '../../../utils';

export const getLocationServicesUrl = () => {
    const deployLevel = getECSDeployLevel();
    return `https://location-services.${deployLevel}.milkmoovement.io/v1`;
};
